import axios from 'axios';

// TODO: type this
export const startNewMfaVerification = async (body) => {
  const res = await axios.post('../mfa/start-new-enrollment-verification', body);
  return res.data;
};

// TODO: type this
export const getMfaEnrollments = async (body) => {
  const res = await axios.post('../mfa/get-enrollments', body);
  return res.data;
};

// TODO: type this
export const removeMfaEnrollment = async (body) => {
  const res = await axios.post('../mfa/remove-enrollment', body);
  return res.data;
};
